const Contact = {
  key_name: "",
  value: "",
  date: new Date().toISOString().split('T')[0],
  kunde: {id: ''},
  person: {id: ''},
};

export default Contact;
